import * as React from "react"
import { CardModal, CardModalType } from "../modal"
import "./style.scss"

export default class PriorityFilter extends React.Component<Props, State> {
	constructor(props: Readonly<Props>) {
		super(props)
		this.state = { selectedPriorities: [], showSelector: false }
	}

	componentDidMount() {
		if(this.props.selectedPriorities && this.props.selectedPriorities.length) {
			const selectedPriorities = this.props.selectedPriorities.map(e => parseInt(e.toString()))
			this.setState({ selectedPriorities, showSelector: false }, () => {
				this.props.onPrioritiesChange(selectedPriorities)
			})
		}
	}

	render() {
		return <div>
			{this.renderButton()}
			{this.state.showSelector && this.renderDialog()}
		</div>
	}

	private handleSubmit(e: React.SyntheticEvent<Element>): void {
		e.preventDefault()

		const formData = new FormData(e.target as HTMLFormElement)
		const priorityEntries = formData.getAll("priority")
		const selectedPriorities = priorityEntries.map(e => parseInt(e.toString()))
		this.setState({ selectedPriorities, showSelector: false }, () => {
			this.props.setSelectedPriorities(selectedPriorities)
			this.props.onPrioritiesChange(selectedPriorities)
		})
	}

	private renderButton(): React. ReactNode {
		let selectedPrioritiesLabel = "Toutes"

		if (this.state.selectedPriorities.length) {
			selectedPrioritiesLabel = this.state.selectedPriorities.sort().join(", ")
		}

		return <button
		className="button button-default"
		title="Filtrer les prorités"
		onClick={e => {if(this.props.pageTitle !== 'Scénarii de fonctionnement') this.setState({ showSelector: true })}}>
			Priorités : {selectedPrioritiesLabel}
		</button>
	}

	private renderDialog(): React.ReactNode {
		return <CardModal
		active={true}
		title="Filtrer les priorités"
		type={CardModalType.ValidCancel}
		onClickCloseButton={() => this.setState({ showSelector: false })}
		onClickFooterButton={() => this.setState({ showSelector: false })}
		onSubmit={e => this.handleSubmit(e)}>
			<div className="prio-chooser-container">
				 <div className="prio-chooser">
					 {[1, 2, 3, 4].map((p, i) => this.renderPriorityChecker(p, i))}
				</div>
			</div>
		</CardModal>
	}

	private renderPriorityChecker(priority: number, index: number): any {
		const checked = !!this.state.selectedPriorities.some(p => priority === p)
		return <label className="prio-item" key={index}>
			<input
			defaultChecked={checked}
			name="priority"
			type="checkbox"
			value={priority}/>&nbsp;
			Priorité {priority}
		</label>
	}
}

interface Props {
	pageTitle: string;
	setSelectedPriorities(priorities: number[]): void;
	selectedPriorities?: number[];
	onPrioritiesChange(priorities: number[]): void;
}

interface State {
	selectedPriorities: number[];
	showSelector: boolean;
}



// WEBPACK FOOTER //
// ./src/component/priority-filter/index.tsx